import { safeNumber } from 'helper/common'
import { Chips } from '../../Chips/Chips'
import { MenuItemWithBadgeProps } from './types'

export const MenuItemWithBadge = ({
  badgeText,
  label
}: MenuItemWithBadgeProps) => (
  <div className="flex align-center gap-8">
    {label}
    {!!badgeText && (
      <Chips.Menu>{safeNumber(badgeText) > 100 ? '99+' : badgeText}</Chips.Menu>
    )}
  </div>
)
